import { createRouter, createWebHistory } from 'vue-router'
import {get_routes} from "@/service/api";

const nullPage = () => import('@/views/NullPage.vue')

let loaded_routes = false;
let try_after_routes = false;
// 这里是静态的路由
const routes=[
  {
    path: "/404",
    name: "404",
    component: nullPage
  },
  {
    path: "/",
    redirect: '/docs/grasshopper/Params',
  },
  {
    path: '/gh/:catchAll(.*)',
    redirect: to => {
      return '/docs/grasshopper/' + to.params.catchAll
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


// 这段也是从 vant-base 范例中复制过来的，这样就可以设置不同页面的标题了
router.beforeEach(async (to, from, next) => {
  // 如果路由未加载完成，从服务器获取路由
  if (!loaded_routes) {
    //let server_routes = []
    await get_routes().then(response => {
      response.data.forEach((i) => {
        let componentName = i.component
        i.component=() => import(`@/views/${componentName}.vue`)
        if (i.children){
          i.children.forEach((j) => {
            componentName= j.component
            j.component=() => import(`@/views/${componentName}.vue`)
          })
        }
        router.addRoute(i)
      })
      loaded_routes = true;
    }).catch(error => {
      console.error('Failed to fetch routes from backend!', error);
    })
  }
  // 根据 to.name 来判断是否为动态路由
  if(!to.name){
    // 判断是否载入了服务器获取的路由
    if (!loaded_routes){
      // 如果路由未加载完成，继续尝试跳转
      next({...to, replace: true})
    }else{
        // 如果路由已经加载完成，但是还是无法找到对应的路由，跳转到 404 页面
      if (!try_after_routes){
        next({...to, replace: true})
        try_after_routes = true;
      }else{
        next({name: '404'})
      }
    }
  }else{
    const title = to.meta && to.meta.title;
    if (title) {
      document.title = title;
    }
    next();
  }
});



export default router
